import { Component, computed, effect, inject, input, signal, untracked } from "@angular/core";
import { TranslatePipe } from "@ngx-translate/core";
import { filter, map } from "rxjs";

import { DataEntryMetricModel, WorkflowDiffVersionType } from "../../../../../../models";
import { MetricApiService } from "../../../../../../services";
import { NormalDiffViewComponent } from "../../_lib";
import { commonMetricValueScreenConfig } from "./metric-actual-value-screen-config";

@Component({
  selector: "adaa-metric-actual-value-screen",
  imports: [TranslatePipe, NormalDiffViewComponent],
  templateUrl: "./metric-actual-value-screen.html",
  styleUrl: "./metric-actual-value-screen.scss",
})
export class MetricActualValueScreenComponent {
  private readonly _metricApiService = inject(MetricApiService);

  showOnlyNew = input.required<boolean>();
  isNew = input<boolean>(false);
  newObject = input.required<WorkflowDiffVersionType>();
  oldObject = input.required<WorkflowDiffVersionType>();
  viewOnlyDifferences = input<boolean>(false);

  isReady = signal<boolean>(false);
  metricsData = signal<DataEntryMetricModel | undefined>(undefined);

  newData = computed<WorkflowDiffVersionType>(() => this._withMetricsData(this.newObject()));
  oldData = computed<WorkflowDiffVersionType>(() => this._withMetricsData(this.oldObject()));

  readonly config = commonMetricValueScreenConfig;

  private _withMetricsData(object: WorkflowDiffVersionType): WorkflowDiffVersionType {
    const metricsData = this.metricsData();
    if (!metricsData) return object;
    return { ...metricsData, ...object };
  }

  constructor() {
    effect(() => {
      const data = this.newObject();

      untracked(() => {
        this._metricApiService
          .getById(data.metricId as number)
          .pipe(
            filter((res) => !res.inError),
            map((res) => res.responseData)
          )
          .subscribe({
            next: (data) => {
              this.metricsData.set(data);
              this.isReady.set(true);
            },
          });
      });
    });
  }
}
